import React from 'react';
import { useIsAppointmentListLoading } from '../../../../utilities/order/scheduling/useIsAppointmentListLoading';
import { LoadingMessage } from './LoadingMessage';
import { EmptyMessage } from './EmptyMessage';

export const ListGuard: React.FC<{
  length: number;
  onAddEventClick: React.MouseEventHandler<HTMLElement>;
  children: React.ReactNode;
}> = ({ children, length, onAddEventClick }) => {
  const isLoading = useIsAppointmentListLoading();

  if (isLoading) {
    return <LoadingMessage />;
  }
  if (length === 0) {
    return <EmptyMessage onAddEventClick={onAddEventClick} />;
  }

  return <div className="gap-0">{children}</div>;
};
